export const isAllInspectorsSelected = (selectedInspectorIds = [], inspectorItems = []) =>
  selectedInspectorIds.includes('all') ||
  (inspectorItems.length > 0 && selectedInspectorIds.length === inspectorItems.length);
